import { type ReactElement } from 'react'
import { NormalLink } from '../../../../../shared/components/ui/links/NormalLink'
import { ACCESSIBILITY_STATEMENT_URL, PRIVACY_POLICY_URL } from '../../../../../shared/utils/commonUrls'

export function FooterDisclaimer (): ReactElement {
  return (
    <>
      <div className="text-xs text-center tracking-tight text-wpy-medium-gray-500 mt-8">
        @ 2022 WastePay. All Rights Reserved.
      </div>
      <div className="flex justify-center mt-2">
        <NormalLink
          additionalClasses="text-xs"
          additionalProps={{ rel: 'noopener noreferrer', target: '_blank' }}
          href={PRIVACY_POLICY_URL}
          text="Privacy Policy"
        />
        <span className="text-wpy-blue-700 text-xs mx-1">·</span>
        <NormalLink
          additionalClasses="text-xs"
          additionalProps={{ rel: 'noopener noreferrer', target: '_blank' }}
          href={ACCESSIBILITY_STATEMENT_URL}
          text="Accessibility Statement"
        />
      </div>
    </>
  )
}
